import { PROXY_FONT_ROUTE } from './constants';

/**
 *
 * @param form
 * @param resolve
 * @returns {Promise<Response | never>}
 */
const getFont = ( form, resolve ) => {
    const options = {
        method: 'POST',
        // headers: {
        //     "Content-type": "multipart/form-data; charset=UTF-8" },
        body: form
    };

    return fetch( PROXY_FONT_ROUTE, options )
        .then( ( response ) => {
            const rsdJson = response.json();

            if ( response.status === 200 || response.status === 201 ) {
                if ( typeof resolve === 'function' ) {
                    resolve( true );
                }
                return rsdJson;
            } else if ( response.status === 400 || response.status === 401 ) {
                if ( typeof resolve === 'function' ) {
                    resolve( false );
                }
                return rsdJson;
            }
        } )
        .then( ( data ) => {
            return data;
        } )
        .catch( ( err ) => {
            console.error( 'Request failed', err );
        } );

};

export { getFont };